import React from 'react';
import './HomeBlocks.css';

/** Blank space between blocks, with an optional divider line down the middle. */
function SpacerBlock({ section }) {
  const height = section.spacerHeight || 48;

  return (
    <div className="home-spacer" style={{ height: `${height}px` }} aria-hidden="true">
      {section.divider && <span className="home-spacer-divider" />}
    </div>
  );
}

export default SpacerBlock;
